module.exports = __webpack_public_path__ + "6efd1557c1edc7a7ee65ea47ef13f64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/5.00ct.png
// module id = 815
// module chunks = 0